import React, {Component} from 'react';
import { connect } from 'react-redux'
import {Link} from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { Navigate , Route } from "react-router-dom";
//import ProtectedRoute from 'protectedRoutes'
class ErrorPage extends Component {
 
    constructor (props) {
        super (props)

        this.state = {
            limit: 5,
            hasMoreItems: true,
            username:'',
            password:''
        };

   //     this.handleSubmit = this.handleSubmit.bind(this); 
    }
 
    render (){
      //  const {products, addToCart, symbol, addToWishlist, addToCompare} = this.props;
      return (
        <div>
   
        <div id="load_screen"> <div className="loader"> <div className="loader-content">
              <div className="spinner-grow align-self-center" />
            </div></div></div>
          {/* END GLOBAL MANDATORY STYLES */}
          <div className="container-fluid">
          <div className="row">
            <div className="col-md-4 mr-auto mt-5 text-md-left text-center">
               
                <img alt="" src=" " className="theme-logo" />
             
            </div>
          </div>
        </div>
        <div className="container-fluid error-content">
          <div className>
            <h1 className="error-number">404</h1>
            <p className="mini-text">Ooops!</p>
            <p className="error-text mb-4 mt-1">The page you requested was not found!</p>
         
          </div>
        </div>    
        {/* BEGIN GLOBAL MANDATORY SCRIPTS */}
        {/* END GLOBAL MANDATORY SCRIPTS */}
        </div>
      );
    }
}
 
export default ErrorPage; 